import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'decodeHtmlString' })
export class DecodeHtmlString implements PipeTransform {
  transform(value: string) {
    // Decode HTML entities without an innerHTML sink (avoids DOM-based XSS).
    const parsed = new DOMParser().parseFromString(value, 'text/html');
    return parsed.documentElement.textContent ?? '';
  }
}
